import { formatINR } from "@/lib/format";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

const DETAILS = [
  ["name", "Project / Work Name"], ["client", "Client / Department"], ["location", "Location"], ["work_order_no", "Tender / Work Order No."],
];

export function SettingsTab({ project, calc, update }) {
  const num = (k) => (e) => update({ [k]: e.target.value === "" ? 0 : Math.min(100, Math.max(0, Number(e.target.value))) });
  return (
    <div className="grid grid-cols-1 xl:grid-cols-2 gap-6">
      <section className="bg-white border border-slate-200 rounded-sm shadow-sm p-6">
        <h3 className="font-heading text-lg font-bold text-slate-900">Project details</h3>
        <div className="mt-5 space-y-4">
          {DETAILS.map(([k, l]) => (
            <div key={k} className="space-y-1.5">
              <Label htmlFor={`set-${k}`}>{l}</Label>
              <Input id={`set-${k}`} data-testid={`settings-${k}-input`} value={project[k] || ""} className="rounded-sm"
                onChange={(e) => update({ [k]: e.target.value })} />
            </div>
          ))}
        </div>
      </section>
      <section className="space-y-6">
        <div className="bg-white border border-slate-200 rounded-sm shadow-sm p-6">
          <h3 className="font-heading text-lg font-bold text-slate-900">Tender % below Govt rate</h3>
          <p className="text-sm text-slate-500 mt-1">The percentage you quote below the Government rate. Applied to every item without its own override.</p>
          <div className="mt-4 flex items-end gap-4">
            <div className="space-y-1.5 w-40">
              <Label htmlFor="set-ded">% Below Govt Rate</Label>
              <Input id="set-ded" type="number" step="0.01" data-testid="settings-deduction-input" value={project.default_deduction} onChange={num("default_deduction")} className="rounded-sm tabular" />
            </div>
            <p className="text-sm text-slate-600 pb-2 tabular">Amount below Govt rate: <b>{formatINR(calc.deductionAmount)}</b></p>
          </div>
        </div>
        <div className="bg-white border border-slate-200 rounded-sm shadow-sm p-6">
          <h3 className="font-heading text-lg font-bold text-slate-900">GST</h3>
          <p className="text-sm text-slate-500 mt-1">Calculated on revenue after deduction, split equally into CGST and SGST.</p>
          <div className="mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4 items-end">
            <div className="space-y-1.5">
              <Label htmlFor="set-gst">GST %</Label>
              <Input id="set-gst" type="number" step="0.01" data-testid="settings-gst-input" value={project.gst_rate} onChange={num("gst_rate")} className="rounded-sm tabular" />
            </div>
            <div className="p-3 bg-slate-50 border border-slate-200 rounded-sm" data-testid="settings-cgst">
              <div className="text-[11px] uppercase text-slate-500 tracking-wide">CGST {(calc.gstRate / 2).toFixed(2)}%</div>
              <div className="font-semibold tabular text-slate-900">{formatINR(calc.cgst)}</div>
            </div>
            <div className="p-3 bg-slate-50 border border-slate-200 rounded-sm" data-testid="settings-sgst">
              <div className="text-[11px] uppercase text-slate-500 tracking-wide">SGST {(calc.gstRate / 2).toFixed(2)}%</div>
              <div className="font-semibold tabular text-slate-900">{formatINR(calc.sgst)}</div>
            </div>
          </div>
          <p className="mt-4 text-sm text-slate-600 tabular">Total GST: <b>{formatINR(calc.gst)}</b> · Bill incl. GST: <b>{formatINR(calc.revenueWithGst)}</b></p>
        </div>
      </section>
    </div>
  );
}
